import { render, staticRenderFns } from "./NavMenuLink.vue?vue&type=template&id=bec358ec&scoped=true"
import script from "./NavMenuLink.vue?vue&type=script&lang=js"
export * from "./NavMenuLink.vue?vue&type=script&lang=js"
import style0 from "./NavMenuLink.vue?vue&type=style&index=0&id=bec358ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec358ec",
  null
  
)

export default component.exports